import { Card, Col, Row } from 'antd'
import KList from 'app/components/Modules/List/_KList'
import KCard from 'app/components/UI-Elements/DataDisplay/KCard'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import useTranslation from 'app/lib/hooks/useTranslation'
import { RecordTypeEnum } from 'app/queries'
import * as React from 'react'

import LineItemImage from '../LineItem/Image'

type Props = {
  onItemClick?: (item: IRecentMachine) => void
}

const { Meta } = Card

const RecentMachinesList: React.FC<Props> = ({ onItemClick }) => {
  const { tAttribute } = useTranslation({ recordType: RecordTypeEnum.recentMachine })

  return (
    <KList<IRecentMachine>
      itemLayout="vertical"
      recordType={RecordTypeEnum.recentMachine}
      footer={null}
      displayHeader
      hideIfEmpty
      queryOptions={{
        hasPagination: false
      }}
      renderItem={(item) => (
        <KCard onClick={() => onItemClick && onItemClick(item)} size="small" hoverable>
          <Meta
            avatar={<LineItemImage member={item} />}
            title={<span className="text-bold text-lg black">{item.categorySegment.name}</span>}
            description={
              <Row>
                <KCol span={24} hidden={!item.product?.name}>
                  <p className="m-0 black">{item.product?.name}</p>
                </KCol>
                <If condition={item.project?.name}>
                  <Col span={24}>
                    <p className="black m-0">
                      {tAttribute(
                        {
                          id: 'projectName'
                        },
                        { projectName: item.project?.name }
                      )}
                    </p>
                  </Col>
                </If>
              </Row>
            }
          />
        </KCard>
      )}
    />
  )
}

export default RecentMachinesList
